const BACK_SOURCE_KEY = 'organization-management-back-source'
const ORG_LIST_BACK_SOURCE = 'org-list'
const APP_BACK_PREFIX = 'app:'
const DEFAULT_APP_BACK_PATH = '/landing-page'

export const markOrganizationManagementOpenedFromOrgList = () => {
  sessionStorage.setItem(BACK_SOURCE_KEY, ORG_LIST_BACK_SOURCE)
}

export const markOrganizationManagementOpenedFromApp = (returnPath = DEFAULT_APP_BACK_PATH) => {
  sessionStorage.setItem(BACK_SOURCE_KEY, `${APP_BACK_PREFIX}${returnPath}`)
}

export const isOrganizationManagementOpenedFromOrgList = () =>
  sessionStorage.getItem(BACK_SOURCE_KEY) === ORG_LIST_BACK_SOURCE

export const getOrganizationManagementAppBackPath = () => {
  const source = sessionStorage.getItem(BACK_SOURCE_KEY) || ''

  if (!source.startsWith(APP_BACK_PREFIX)) {
    return DEFAULT_APP_BACK_PATH
  }

  return source.slice(APP_BACK_PREFIX.length) || DEFAULT_APP_BACK_PATH
}

export const clearOrganizationManagementBackSource = () => {
  sessionStorage.removeItem(BACK_SOURCE_KEY)
}
